import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/Telematics/telematics__en-US.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade: Telematics',
    metaTitle: 'Lemonade: Telematics',
    description:
      'Explore the terms and conditions for Lemonade’s telematics features, including data usage, eligibility, and participant responsibilities.',
  },
  MDXContent: content as DocumentTypes,
};
